// extracted by mini-css-extract-plugin
export var companyInfo = "Footer-module--companyInfo--oJJzs";
export var footer = "Footer-module--footer--ZibDa";
export var footerContainer = "Footer-module--footerContainer--51w3f";
export var icon = "Footer-module--icon--XFY7d";
export var linkList = "Footer-module--linkList--N71Wd";
export var socialList = "Footer-module--socialList--njHVu";